import { render, staticRenderFns } from "./EditPersonalInformation.vue?vue&type=template&id=fb3bde6c&scoped=true"
import script from "./EditPersonalInformation.vue?vue&type=script&lang=js"
export * from "./EditPersonalInformation.vue?vue&type=script&lang=js"
import style0 from "./EditPersonalInformation.vue?vue&type=style&index=0&id=fb3bde6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3bde6c",
  null
  
)

export default component.exports